module.exports = __webpack_public_path__ + "static/DevOps-Automation-2cd0fe2f3e823c06cf62400980a11fa5.jpg";